module.exports = __webpack_public_path__ + "static/media/王小毅@2x.f10e9f81.png";